export enum EXTENSIONS {
  ICO = '.ico',
}
